var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 448,
    viewBox: "0 0 463 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.442 328.738C440.611 334.582 437.473 340.293 434.071 345.814C432.776 347.896 431.472 349.929 430.114 351.958C422.57 363.241 413.83 373.696 404.116 383.229C402.28 385.056 400.417 386.831 398.482 388.575C387.571 398.556 375.52 407.434 362.613 415.089C360.113 416.608 357.555 418.054 354.959 419.456C339.457 427.878 322.802 434.577 305.398 439.358C301.754 440.379 298.086 441.275 294.39 442.103C268.013 448.04 240.181 449.625 212.143 446.187C203.34 445.125 194.522 443.56 185.723 441.467C160.915 435.621 136.228 425.669 112.604 411.176L302.971 17.5427C329.238 26.9704 352.546 40.2996 372.692 56.4833C379.565 61.9869 386.077 67.8503 392.181 73.9751C411.925 93.6999 427.77 116.417 439.407 140.672C441.03 144.075 442.583 147.52 444.058 150.982C451.085 167.593 456.19 184.802 459.286 202.202C459.795 205.119 460.264 208.025 460.652 210.941C462.736 225.855 463.325 240.854 462.346 255.631C462.19 258.234 461.965 260.812 461.71 263.387C460.319 276.974 457.621 290.352 453.514 303.289C452.794 305.632 452.016 307.921 451.175 310.232C448.938 316.525 446.356 322.701 443.442 328.738Z",
    fill: "#00B500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M392.181 73.9757L274.214 16.9209L277.375 10.3866L372.692 56.4833C379.565 61.9869 386.076 67.8503 392.181 73.9757Z",
    fill: "#008700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M444.058 150.982L253.866 59.0038L257.022 52.466L439.407 140.672C441.03 144.076 442.583 147.52 444.058 150.982Z",
    fill: "#008700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M460.652 210.941L233.509 101.087L236.674 94.5448L459.286 202.202C459.795 205.12 460.264 208.026 460.652 210.941Z",
    fill: "#008700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M461.71 263.387L213.153 143.176L216.314 136.64L462.346 255.631C462.19 258.234 461.965 260.812 461.71 263.387Z",
    fill: "#008700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M451.175 310.232L192.8 185.269L195.958 178.74L453.514 303.289C452.794 305.632 452.016 307.921 451.175 310.232Z",
    fill: "#008700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M434.071 345.814C432.776 347.896 431.472 349.929 430.113 351.958L172.452 227.35L175.611 220.814L434.071 345.814Z",
    fill: "#008700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M404.117 383.23C402.28 385.056 400.418 386.831 398.483 388.575L152.098 269.42L155.267 262.886L404.117 383.23Z",
    fill: "#008700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M362.614 415.088C360.113 416.607 357.555 418.053 354.96 419.455L131.746 311.506L134.911 304.962L362.614 415.088Z",
    fill: "#008700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M305.399 439.358C301.754 440.379 298.087 441.275 294.39 442.103L111.384 353.605L114.551 347.061L305.399 439.358Z",
    fill: "#008700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M212.144 446.187C203.341 445.125 194.523 443.56 185.723 441.467L91.0399 395.674L94.1982 389.147L212.144 446.187Z",
    fill: "#008700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M417.394 315.572C364.652 424.616 233.487 470.274 124.43 417.53C15.3766 364.788 -30.2705 233.629 22.4719 124.589C75.215 15.5155 206.369 -30.134 315.428 22.6097C424.484 75.348 470.134 206.509 417.394 315.572Z",
    fill: "#00C800"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M411.32 312.639C360.199 418.351 233.065 462.592 127.363 411.476C21.6641 360.353 -22.5864 233.227 28.5382 127.521C79.6564 21.8173 206.794 -22.4445 312.493 28.6802C418.191 79.7942 462.441 206.936 411.32 312.639Z",
    fill: "#00B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M384.104 296.592C383.918 296.983 383.722 297.38 383.502 297.738C340.215 385.67 232.967 421.798 143.349 378.456C53.7094 335.098 15.4485 228.609 57.4978 140.079C57.6595 139.69 57.8512 139.287 58.0388 138.893C98.9406 54.3186 198.783 17.0442 286.011 51.466C288.875 52.5793 291.715 53.7882 294.551 55.0868C295.963 55.7157 297.371 56.3765 298.781 57.0592C300.185 57.7448 301.575 58.4368 302.952 59.149C305.725 60.5602 308.438 62.05 311.09 63.5911C392.213 110.6 425.009 212.026 384.104 296.592Z",
    fill: "#009900"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.97 298.926C339.431 388.967 231.112 426.638 141.096 383.104C51.0492 339.554 13.3664 231.279 56.9084 141.233C57.0967 140.852 57.2878 140.45 57.4984 140.079C15.4485 228.609 53.71 335.098 143.35 378.456C232.968 421.798 340.216 385.67 383.503 297.738C383.353 298.146 383.16 298.539 382.97 298.926Z",
    fill: "#008700"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.051 191.46L178.907 100.6H120.732V187.33H95.3617V218.6H151.412V131.87H160.229L208.373 222.14H340.802V191.46H227.051Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.852 287.036L244.047 234.53H95.3617V265.8H227.522L270.641 330.11H310.122V265.8H340.802V234.53H278.852V287.036Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M152.002 274.65H121.322V330.11H152.002V274.65Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M309.532 104.14H278.262V182.02H309.532V104.14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgnt);
export default __webpack_public_path__ + "static/media/NGNT.8329d84f312dbca568ca6ad4fb9584c8.svg";
export { ForwardRef as ReactComponent };